import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { AppointmentService } from 'src/app/core/service/appointment.service';
import { AppointmentConfirm } from '../model/appointment-confirm';

@Component({
  standalone: false,
  selector: 'app-appointment-confirm',
  templateUrl: './appointment-confirm.component.html',
  styleUrls: ['./appointment-confirm.component.scss']
})
export class AppointmentConfirmComponent implements OnInit
{

  public model: AppointmentConfirm = new AppointmentConfirm();
  public validating = true;
  public isValidToken = false;
  public appointment: any;
  public event: any;

  constructor(
    private appointmentService: AppointmentService,
    private route: ActivatedRoute
  ) { }

  public ngOnInit(): void
  {
    this.validating = true;
    this.isValidToken = false;
    this.route.params.forEach((params: Params) =>
    {
      if (params.token !== undefined && params.confirm !== undefined)
      {
        this.model.token = params.token;
        this.model.confirm = params.confirm;
        this.appointmentService.confirmAppointment(this.model).subscribe({
          next: (data) =>
          {
            if (data !== null && data !== undefined)
            {
              this.isValidToken = true;
              this.appointment = data.appointment;
              this.event = data;
            }
            else
            {
              this.isValidToken = false;
            }
          },
          complete: () =>
          {
            this.validating = false;
          }
        });
      }
    });
  }
}
